import {
  AttributesService,
  AttributesProvider,
  Attribute,
  HttpService,
} from "@sportal/api";

const attributesMap = {
  [Attribute.LANGUAGE]: "nom.smb.language",
  [Attribute.TIME_FORMAT]: "nom.smb.format24h",
  [Attribute.EMAIL]: "nom.smb.email",
  [Attribute.EMAIL_FREQUENCY]: "nom.smb.email.frequency",
  [Attribute.BUSINESS_NAME]: "nom.smb.businessname",
};

export const makeAttributesService = (
  http: HttpService,
  baseUrl: string
): AttributesService =>
  new AttributesService(new AttributesProvider(http, baseUrl, attributesMap));
